/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SuccessResponse } from '../housien-models/SuccessResponse';
import type { UserInput } from '../housien-models/UserInput';
import type { UserResponse } from '../housien-models/UserResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPIHousien } from '../core/OpenAPI';
import { request as __request } from '../core/request';

/**
 * UserService class.
 */
export class UserService {

    /**
     * Register a new user
     * Register a new user with the given information
     * @param requestBody 
     * @returns SuccessResponse User registered successfully.
     * @throws ApiError
     */
    public static createUser(
requestBody: UserInput,
): CancelablePromise<SuccessResponse> {
        return __request(OpenAPIHousien, {
            method: 'POST',
            url: '/user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Get user information
     * Retrieve information of an authenticated user.
     * @returns UserResponse User retrieved successfully.
     * @throws ApiError
     */
    public static getUser(): CancelablePromise<UserResponse> {
        return __request(OpenAPIHousien, {
            method: 'GET',
            url: '/user',
        });
    }

}
